import RouterPage from "./RouterPage";

function App() {
  return (
    <div className="bg-gray-100">
      <RouterPage />
    </div>
  );
}

export default App;
